<template>
  <div class="pa-3 grey lighten-4">
    <v-card class="card--flex-toolbar">
      <v-card-text class="pa-0">
          <PageOverview v-if="page" :page.sync="page" @onSave="savePage"></PageOverview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import PageOverview from "@/components/admin/pages/Overview";
import PageWidgets from "@/components/admin/pages/Widgets";

export default {
  name:"AdminPageSave",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getAdminPagesFromApi();
    });
  },
  components: {
    PageOverview,
    PageWidgets
  },
  data() {
    return {
      active: null,
      current_tab: 'basic-details',
      tabs: [
          {
            text: i18n.t('admin.page.update.tabs.basic-details.title'),
            href: '#basic-details'
          },
          {
            text: i18n.t('admin.page.update.tabs.widget.title'),
            href: '#widgets'
          },
      ]
    }
  },
  computed: {
    ...mapGetters("adminPage", {
      page: "homepage",
    }),
  },
  methods:{
    async getAdminPagesFromApi()
    {
      try {
        var response = await this.$store.dispatch("adminPage/list", {});
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
    async savePage(page) {
      try {
        var response = await this.$store.dispatch("adminPage/update", page);
        this.$store.dispatch("app/showMessage", {
          message: "Updated Successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
  }
}
</script>

<style>

</style>
